module.exports = __webpack_public_path__ + "static/media/zipwater.93f65ef7.png";